import React, { useEffect, useState } from 'react'
import { lotteryService } from '../../services/lotteryService'
import { formatCloseTimeCompact, isClosingSoon } from './berThongUi'

type Props = {
  closeAt?: string | null
  className?: string
}

function remainingText(closeAt?: string | null): string {
  if (!closeAt) return '—'
  return lotteryService.formatTimeRemaining(closeAt)
}

/**
 * Same live pattern as lobby-huay listall CountdownDisplay:
 * own setInterval + local state (does not depend on parent nowMs / hover repaint).
 */
export function BerThongCountdown({ closeAt, className = '' }: Props) {
  const [left, setLeft] = useState(() => remainingText(closeAt))
  const [urgent, setUrgent] = useState(() => isClosingSoon(closeAt))

  useEffect(() => {
    if (!closeAt) {
      setLeft('—')
      setUrgent(false)
      return
    }

    const tick = () => {
      setLeft(remainingText(closeAt))
      setUrgent(isClosingSoon(closeAt, Date.now()))
    }

    tick()
    const id = window.setInterval(tick, 1000)
    return () => window.clearInterval(id)
  }, [closeAt])

  const closeLabel = closeAt ? formatCloseTimeCompact(closeAt) : '—'
  const expired = left === 'ปิดรับแทง'

  return (
    <div
      className={`htd-bt__metrics${urgent ? ' is-urgent' : ''}${expired ? ' is-closed' : ''} ${className}`.trim()}
    >
      <div className="htd-bt__metric">
        <small>เวลาเหลือ</small>
        <strong className="htd-bt__metric-countdown">{left}</strong>
      </div>
      <div className="htd-bt__metric">
        <small>ปิดรับ</small>
        <strong className="htd-bt__metric-close">{closeLabel}</strong>
      </div>
    </div>
  )
}

export default BerThongCountdown
